(function () {
  'use strict';

  var mqlDesktop =
    typeof window.matchMedia === 'function'
      ? window.matchMedia('(min-width: 768px)')
      : { matches: true };

  var MEGA_IMG_MAX = 200;
  var MEGA_IMG_SM = 120;
  var cache = {};

  function rootUrl() {
    var r = (window.FoxTheme && FoxTheme.routes && FoxTheme.routes.root_url) || '/';
    return r.endsWith('/') ? r : r + '/';
  }

  function formatPrice(price) {
    if (!window.FoxTheme || !FoxTheme.Currency || !FoxTheme.settings) return '';
    return FoxTheme.Currency.formatMoney(price, FoxTheme.settings.moneyFormat);
  }

  function escapeHtml(str) {
    if (!str) return '';
    var d = document.createElement('div');
    d.textContent = str;
    return d.innerHTML;
  }

  function truncate(str, n) {
    if (!str || str.length <= n) return str || '';
    return str.slice(0, n - 1) + '\u2026';
  }

  function activatePanel(mega, activeLink) {
    mega.querySelectorAll('.smart-mega__link').forEach(function (l) {
      l.classList.remove('is-active');
    });
    mega.querySelectorAll('.smart-mega__panel').forEach(function (p) {
      p.classList.remove('is-active');
    });
    activeLink.classList.add('is-active');
    var panelId = activeLink.getAttribute('data-panel-id');
    if (!panelId) return;
    var t = mega.querySelector('#' + CSS.escape(panelId));
    if (t) t.classList.add('is-active');
  }

  function imgSized(src, w) {
    return src + (src.indexOf('?') !== -1 ? '&' : '?') + 'width=' + w;
  }

  function productImgSrc(p) {
    var fi = p.featured_image;
    if (typeof fi === 'string' && fi) return fi;
    if (fi && typeof fi === 'object' && fi.src) return fi.src;
    if (p.images && p.images.length) {
      var f = p.images[0];
      return typeof f === 'string' ? f : (f && f.src) || '';
    }
    return '';
  }

  function renderProduct(p) {
    var v = p.variants && p.variants[0];
    var raw = v && v.price != null ? v.price : p.price;
    var price = raw != null ? formatPrice(raw) : '';
    var title = truncate(p.title, 30);
    var rawSrc = productImgSrc(p);
    var imgHtml;

    if (rawSrc) {
      var src = rawSrc.indexOf('//') === 0 ? 'https:' + rawSrc : rawSrc;
      imgHtml =
        '<div class="smart-mega__product-img"><img class="smart-mega__img" src="' +
        escapeHtml(imgSized(src, MEGA_IMG_MAX)) +
        '" srcset="' +
        escapeHtml(imgSized(src, MEGA_IMG_SM)) + ' ' + MEGA_IMG_SM + 'w, ' +
        escapeHtml(imgSized(src, MEGA_IMG_MAX)) + ' ' + MEGA_IMG_MAX + 'w' +
        '" sizes="' + MEGA_IMG_SM + 'px" alt="' +
        escapeHtml(p.title) +
        '" width="' + MEGA_IMG_MAX + '" height="' + Math.round((MEGA_IMG_MAX * 4) / 3) +
        '" loading="lazy"></div>';
    } else {
      imgHtml =
        '<div class="smart-mega__product-img"><span class="placeholder-svg" style="display:block;min-height:120px;background:rgba(0,0,0,.06)"></span></div>';
    }

    var href = p.url || (p.handle ? '/products/' + p.handle : '');
    if (href.indexOf('/') === 0) href = rootUrl().replace(/\/$/, '') + href;

    return (
      '<a href="' + escapeHtml(href) + '" class="smart-mega__product">' +
      imgHtml +
      '<span class="smart-mega__product-name">' + escapeHtml(title) + '</span>' +
      '<span class="smart-mega__product-price">' + price + '</span></a>'
    );
  }

  function renderEmpty(track) {
    var url = track.dataset.emptyCollectionUrl || '';
    var title = track.dataset.emptyTitle || '';
    track.innerHTML =
      '<div class="smart-mega__empty"><p>' +
      escapeHtml(title) +
      ' koleksiyonunu ke\u015ffedin</p><a href="' +
      escapeHtml(url) +
      '" class="btn btn--primary"><span class="btn__text">Koleksiyona Git</span></a></div>';
    track.dataset.loaded = 'true';
  }

  function fetchCollection(handle, limit) {
    var key = handle + ':' + limit;
    if (cache[key]) return cache[key];
    var url = rootUrl() + 'collections/' + encodeURIComponent(handle) + '/products.json?limit=' + limit;
    cache[key] = fetch(url)
      .then(function (r) {
        if (!r.ok) throw new Error(r.status);
        return r.json();
      })
      .then(function (d) { return (d && d.products) || []; });
    return cache[key];
  }

  function loadTrack(track) {
    if (!track || track.dataset.loaded === 'true' || track.dataset.loading === 'true') return;
    if (!mqlDesktop.matches) return;

    var handle = track.dataset.collectionHandle;
    if (!handle) { renderEmpty(track); return; }

    var limit = parseInt(track.dataset.productLimit || '8', 10) || 8;
    track.dataset.loading = 'true';
    track.innerHTML =
      '<div class="smart-mega__empty smart-mega__empty--loading"><p>Y\u00fckleniyor\u2026</p></div>';

    fetchCollection(handle, limit)
      .then(function (products) {
        if (!products.length) { renderEmpty(track); return; }
        track.innerHTML = products.map(renderProduct).join('');
        track.dataset.loaded = 'true';
      })
      .catch(function () { renderEmpty(track); })
      .finally(function () { delete track.dataset.loading; });
  }

  function loadActivePanelTracks(mega) {
    var panel = mega.querySelector('.smart-mega__panel.is-active') || mega.querySelector('.smart-mega__panel');
    if (!panel) return;
    loadTrack(panel.querySelector('[data-smart-mega-track]'));
  }

  function bindMega(mega) {
    if (!mega || mega.dataset.smartMegaBound === 'true') return;
    mega.dataset.smartMegaBound = 'true';

    mega.querySelectorAll('.smart-mega__link').forEach(function (link) {
      link.addEventListener('mouseenter', function () {
        if (!mqlDesktop.matches) return;
        activatePanel(mega, link);
        var panelId = link.getAttribute('data-panel-id');
        if (!panelId) return;
        var panel = mega.querySelector('#' + CSS.escape(panelId));
        if (panel) loadTrack(panel.querySelector('[data-smart-mega-track]'));
      });
    });
  }

  document.addEventListener(
    'toggle',
    function (ev) {
      var d = ev.target;
      if (!d || d.tagName !== 'DETAILS' || d.getAttribute('is') !== 'details-mega') return;
      if (!d.open) return;
      var mega = d.querySelector('[data-smart-mega]');
      if (!mega) return;
      bindMega(mega);
      if (mqlDesktop.matches) loadActivePanelTracks(mega);
    },
    true
  );

  function initAll() {
    document.querySelectorAll('[data-smart-mega]').forEach(bindMega);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (ev) {
    if (!ev.target || !ev.target.querySelectorAll) return;
    ev.target.querySelectorAll('[data-smart-mega]').forEach(function (m) {
      m.removeAttribute('data-smart-mega-bound');
    });
    initAll();
  });
})();
